export const GET_DATA_MANAGER_SHARED = 'GET_DATA_MANAGER_SHARED';
export const GET_DATA_MANAGER_SHARED_SUCCESS = 'GET_DATA_MANAGER_SHARED_SUCCESS';
export const GET_DATA_MANAGER_SHARED_ERROR = 'GET_DATA_MANAGER_SHARED_ERROR';

export const GET_DATA_MANAGER_EXPORTED = 'GET_DATA_MANAGER_EXPORTED';
export const GET_DATA_MANAGER_EXPORTED_SUCCESS = 'GET_DATA_MANAGER_EXPORTED_SUCCESS';
export const GET_DATA_MANAGER_EXPORTED_ERROR = 'GET_DATA_MANAGER_EXPORTED_ERROR';